"use client";

import type { FeedItems } from "../../../types/content/feedItem";

import { LatestNewsArticleCluster } from "./LatestNewsArticleCluster/LatestNewsArticleCluster";
import { isArticleFeedItem, isInjectable } from "../../../utils/typechecks";
import { InjectablePlaceholder } from "../../Injectable/Injectable";
import { LatestNewsBoxCluster } from "./LatestNewsBoxCluster/LatestNewsBoxCluster";

const LatestNewsLayout = ({
  data,
  isFirstFeed,
}: {
  data: FeedItems;
  isFirstFeed?: boolean;
}) => {
  return (
    <div>
      {data.map((feedGroup, clusterIndex) => {
        if (!feedGroup) return null;

        if (isInjectable(feedGroup)) {
          return (
            <InjectablePlaceholder
              resource={feedGroup}
              key={`${feedGroup.type}${clusterIndex}`}
            />
          );
        }

        const isLastElement = data.length === clusterIndex + 1;
        const isFirstElement = clusterIndex === 0;
        const hasBoxAfter = data?.[clusterIndex + 1]?.type === "Box";
        const hasBoxBefore = data?.[clusterIndex - 1]?.type === "Box";

        const teaserWeight = feedGroup.weight;

        if (feedGroup.type === "Box") {
          return (
            <LatestNewsBoxCluster
              boxGroup={feedGroup}
              boxName={feedGroup.name!}
              positionInFeed={clusterIndex + 1}
              key={`${feedGroup.id}${clusterIndex}`}
              teaserWeight={teaserWeight}
            />
          );
        }

        if (isArticleFeedItem(feedGroup)) {
          const shouldPrioritizeImageLoad = clusterIndex > 3 && isFirstFeed;
          return (
            <LatestNewsArticleCluster
              feedGroup={feedGroup}
              shouldPrioritizeImageLoad={shouldPrioritizeImageLoad}
              isLastElement={isLastElement || hasBoxAfter}
              isFirstElement={isFirstElement || hasBoxBefore}
              key={`${feedGroup.id}${clusterIndex}`}
              positionInFeed={clusterIndex + 1}
              teaserWeight={teaserWeight}
            />
          );
        }
      })}
    </div>
  );
};

export { LatestNewsLayout };
